import React from "react"

export default function Cards({items}) {
    if (!items || items.length === 0) {
    return null; 
  }
  return (
    <div>
      <div className="py-10">
        <h1 className="text-4xl font-segoe font-bold">Research</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full pb-[40px]">
        {items.map((item, index) => (
        <div key={index} className="hover:border-2 hover:border-solid hover:border-primary rounded-xl shadow-xl w-full min-h-[35.70rem] flex flex-col"
        >
        {/* The image */}
        <div className="flex justify-center items-center h-[19.438rem]">
          <img className="w-full h-full object-cover rounded-t-lg" src={item.preview_image_url} alt={item.title}/>
        </div>
        {/* The texts */}
        <div className="flex flex-col justify-between flex-1 px-6 pb-10">
          <div>
            <h3 className="text-[1.5rem] font-segoe text-gray-900 font-bold py-[0.75rem]">
              {item.title}
            </h3>
            <p className="text-[0.875rem] text-pretty font-segoe text-gray-500 font-normal py-[0.75rem]">
              {item.description}
            </p>
          </div>
          <a href={`/researchpaper/${item.id}`} className="text-[1rem] font-segoe hover:text-blue font-semibold pt-[0.75rem]">
            See more &gt;
          </a>
        </div>
      </div>
    ))}
      </div>
    </div>
  )
}
